import { formatMoneyCompact } from '../../lib/format';

/**
 * What somebody is paid, as one answer: "L 16,000 a month", "L 120 an hour".
 *
 * The amount and the basis used to sit in two columns headed "Amount" and "Basis", which is the
 * shape of the compensations table and not the shape of the question — nobody asks what a person's
 * basis is, they ask what the person is paid, and L 16,000 means two wildly different things
 * depending on the column next to it. Kept in one place because the staff list, the person's own
 * page and their pay history must never word the same rate three different ways.
 */
export function payPhrase(amountMinor: number, currency: string, type: string | null | undefined): string {
  return `${formatMoneyCompact(amountMinor, currency)} ${type === 'hourly' ? 'an hour' : 'a month'}`;
}
